'use strict'

function pageMenuPath ({ application, pageUniqueTitle, accessKey, inheritAccessKey }) {

  if (!application || !pageUniqueTitle) return ''

  const parts = [application, pageUniqueTitle]

  if (inheritAccessKey && accessKey) parts.push(accessKey)

  return `/${parts.map(part => encodeURIComponent(part)).join('/')}`
}

function menuLinkUsesButton (item) {

  return !!(item && item.type === 'link' && item.displayAsButton)
}

function menuItemRunsCode (item) {

  return !!(item && item.type === 'code')
}

function pageIsUnder (pages, ancestorUniqueTitle, pageUniqueTitle) {

  if (!ancestorUniqueTitle || !pageUniqueTitle || ancestorUniqueTitle === pageUniqueTitle) return false

  const parentOf = new Map()

  for (const page of pages || []) {

    if (page && page.uniqueTitle) parentOf.set(page.uniqueTitle, page.parentUniqueTitle || '')
  }

  const seen = new Set()
  let current = parentOf.get(pageUniqueTitle) || ''

  while (current && !seen.has(current)) {

    if (current === ancestorUniqueTitle) return true

    seen.add(current)
    current = parentOf.get(current) || ''
  }

  return false
}

module.exports = {
  pageMenuPath,
  menuLinkUsesButton,
  menuItemRunsCode,
  pageIsUnder
}
